import axios from 'axios';

const getCompraConjunta = cotacaoId => axios.get(`/cotacoes-conjuntas/${cotacaoId}/compra-conjunta`);
const comprar = (compraId, data) => axios.post(`/compras-conjuntas/${compraId}/comprar`, data);

export default {
  getCompraConjunta,
  comprar,
};
